import script from "./SidebarSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SidebarSwitcher.vue?vue&type=style&index=0&id=f7953c2e&lang=scss"
import "./SidebarSwitcher.vue?vue&type=style&index=1&id=f7953c2e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7953c2e"]])

export default __exports__